import React, { useState } from "react";
import validator from "validator";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";

import LoadingButton from "../../components/loadingButton";
import api from "../../services/api";

export default () => {
  const [email, setEmail] = useState("");
  const history = useHistory();

  const send = async () => {
    if (!validator.isEmail(email))
      return toast.error("Adresse e-mail invalide");

    try {
      await api.post("/mail/forgottenpassword", { email, language: "fr" });
      toast.success(
        "Si un compte existe pour cet e-mail, un code vient d'être envoyé",
      );
      history.push("/auth/reset", { email });
    } catch (e) {
      toast.error("Impossible d'envoyer le code");
    }
  };

  return (
    <div className="relative">
      <div className="mb-10 max-w-7xl mx-auto p-4">
        {/* <img src={logoImg} /> */}
      </div>

      <div className="max-w-lg mx-auto w-full">
        <h1 className="text-center text-3xl font-semibold text-black mb-12">
          Réinitialiser le mot de passe
        </h1>
        <div className="mb-8 text-[#555]">
          Entrez votre adresse e-mail ci-dessous pour recevoir un code de
          réinitialisation.
        </div>
        <div>
          <div className="flex flex-col gap-y-2 w-full">
            <label htmlFor="email">Adresse e-mail</label>
            <input
              name="email"
              type="email"
              id="email"
              className="w-full"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <LoadingButton
            className="py-3.5 w-full text-center bg-app text-white rounded-lg mt-5"
            type="submit"
            onClick={send}
          >
            Envoyer le code
          </LoadingButton>
        </div>
      </div>
    </div>
  );
};
